import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewProducts } from "./DetailViewProducts";
import { MasterViewProducts } from "./MasterViewProducts";
export var TabProducts = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewProducts, detailRenderer: DetailViewProducts }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/TabProducts.tsx
// module id = 2643
// module chunks = 3